import { Theme } from "../component/navigation/ThemeDropdown";

export default function MapStyleIcon({ theme }: { theme: Theme }) {
    return (
        <svg
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_319_779)">
                <path
                    d="M15.7487 6.67119L12.3538 5.41102L8.136 6.97762C8.05681 7.00516 7.97073 7.00516 7.89154 6.97762L3.64622 5.40069L0.227243 6.67119C-0.0757478 6.78481 -0.0757478 7.21175 0.227243 7.32537L3.63589 8.59242L7.86744 7.02238C7.94663 6.99483 8.03271 6.99483 8.1119 7.02238L12.3434 8.59242L15.7521 7.32537C16.0551 7.21175 16.0551 6.78481 15.7521 6.67119H15.7487Z"
                    fill={theme === "light" ? "#535353" : "#7A8690"}
                />
                <path
                    d="M7.86744 10.1659L3.63589 8.59587L0.227243 9.85948C-0.0757478 9.97311 -0.0757478 10.4 0.227243 10.5137L7.864 13.3508C7.94319 13.3783 8.02927 13.3783 8.10846 13.3508L15.7452 10.5137C16.0482 10.4 16.0482 9.97311 15.7452 9.85948L12.3366 8.59243L8.10501 10.1625C8.02582 10.19 7.93975 10.19 7.86056 10.1625L7.86744 10.1659Z"
                    fill={theme === "light" ? "#535353" : "#7A8690"}
                />
                <path
                    d="M8.10847 3.83409L12.3538 5.41102L15.7762 4.14052C16.0792 4.0269 16.0792 3.59996 15.7762 3.48634L8.13601 0.645796C8.05682 0.618251 7.97075 0.618251 7.89156 0.645796L0.254801 3.48634C-0.0481904 3.59996 -0.0481904 4.0269 0.254801 4.14052L3.64968 5.40069L7.86745 3.83409C7.94664 3.80654 8.03272 3.80654 8.11191 3.83409H8.10847Z"
                    fill={theme === "light" ? "#535353" : "#7A8690"}
                />
            </g>
        </svg>
    );
}
